import React from "react"
import { graphql, StaticQuery } from "gatsby"
import styled from "styled-components"

import tokens from "../_tokens"
import NavItems from "./nav-items"

const StyledSidebarContainer = styled.div`
  color: ${tokens.color.text.base};
  background-color: ${tokens.color.white};
  height: calc(100vh - ${tokens.size.headerHeight}px);
  min-width: ${tokens.size.sidebarWidth}px;
  position: sticky;
  top: ${tokens.size.headerHeight}px;
  border-right: 1px solid ${tokens.color.border};
  overflow: auto;
  display: none;
  flex-direction: column;

  @media screen and (min-width: ${tokens.breakpoint.xl}px) {
    display: flex;
  }
`

function Sidebar() {
  return (
    <StaticQuery
      query={graphql`
        query MenuQuery {
          allNavYaml {
            edges {
              node {
                id
                title
                url
                items {
                  title
                  url
                }
              }
            }
          }
        }
      `}
      render={({ allNavYaml: { edges } }) => {
        const navItems = edges.map(item => item.node)
        return (
          <StyledSidebarContainer>
            <NavItems items={navItems} />
          </StyledSidebarContainer>
        )
      }}
    />
  )
}

export default Sidebar
